import { companyList, companyUpdate, companyInsert, companyInfo, SearchCompany, CompanyRecharge, CompanyRechargeLog, CompanyRechargeConfirm , CompanyUserName} from '@/api/company'
export default {
  state: {

  },
  actions: {
    getCompany({ commit }, payload) {
      return new Promise(resolve => {
        companyList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    insertCompany({ commit }, payload) {
      return new Promise(resolve => {
        companyInsert(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    updateCompany({ commit }, payload) {
      return new Promise(resolve => {
        companyUpdate(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    infoCompany({ commit }, payload) {
      return new Promise(resolve => {
        companyInfo(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SearchCompany({ commit }, payload) {
      return new Promise(resolve => {
        SearchCompany(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    CompanyRecharge({ commit }, payload) {
      return new Promise(resolve => {
        CompanyRecharge(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    CompanyRechargeLog({ commit }, payload) {
      return new Promise(resolve => {
        CompanyRechargeLog(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    CompanyRechargeConfirm({ commit }, payload) {
      return new Promise(resolve => {
        CompanyRechargeConfirm(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    CompanyUserName({ commit }, payload) {
      return new Promise(resolve => {
        CompanyUserName(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  getters: {

  },
  mutations: {

  }
}
